import React from 'react';
import { useDispatch } from 'react-redux';
import { userSession } from '../auth';
import $ from 'jquery';
import './../styles/bootstrap5.1.3.css';
import './../styles/index.css';
import './../styles/arcade.css';
import './../styles/common.css';

import { Signin } from './SignIn';
import { NoNFTMessage } from './NoNFTMessage';
import { InvalidUserMessage } from './InvalidUserMessage';
import { MainMenu } from './menu/MainMenu';
import { logIn, selectNft } from '../store/userStore';
import { contractsNFT } from '../constants/contract';
import { network } from '../constants/network';
import { apiMapping } from '../constants/apiUrl';

export function App() {
  // listen to swap events from the widget

  return (
    <div className="site-wrapper">
      <div className="site-wrapper-inner">
        <Auth />
        {!userSession.isUserSignedIn() ? <Signin /> : <p />}
      </div>
    </div>
  );
}

const Auth = () => {
  const dispatch = useDispatch();

  if (!userSession.isUserSignedIn()) {
    return null;
  }
  function closeGameUnathorizedMove() {
    (document.getElementById('game_racing') as any).style.display = 'none';
    (document.getElementById('unauthorized_modification') as any).style.display = 'block';
  }

  function showHighscoresMain() {
    (document.getElementById('menu_racing') as any).style.display = 'none';
    (document.getElementById('highscores_main') as any).style.display = 'block';
    document.getElementsByTagName('body')[0].style.overflow = 'auto';
  }

  function formatTime(dt: any) {
    var minutes = Math.floor(dt / 60);
    var seconds = Math.floor(dt - minutes * 60);
    var tenths = '';
    if (dt - Math.floor(dt) < 0.1) {
      tenths += '0';
    }
    tenths += Math.floor(10000 * (dt - Math.floor(dt)));

    if (minutes > 0) return minutes + '.' + (seconds < 10 ? '0' : '') + seconds + '.' + tenths;
    else return seconds + '.' + tenths;
  }

  function Get(yourUrl: any) {
    var Httpreq = new XMLHttpRequest(); // a new request
    Httpreq.open('GET', yourUrl, false);
    Httpreq.send(null);
    return Httpreq.responseText;
  }

  var accountAddress = JSON.parse(localStorage.getItem('userData') as any);

  if (accountAddress !== '' && accountAddress !== null) {
    dispatch(logIn(accountAddress));

    let selectedNft = localStorage.nrNFT;
    if (selectedNft !== undefined) {
      if (!selectedNft.includes('#')) localStorage.removeItem('nrNFT');
      else dispatch(selectNft(selectedNft));
    }

    var nrSliced = 4;
    var accountAddressShort =
      accountAddress.slice(0, nrSliced) +
      '...' +
      accountAddress.slice(accountAddress.length - nrSliced, accountAddress.length);

    let url: string = apiMapping[network](accountAddress).balance;

    var json_obj = JSON.parse(Get(url));
    var typeOfToken = 'non_fungible_tokens';
    console.log(json_obj);

    const contractsNFTs = contractsNFT[network];
    const assetIdentifierMiami: string = contractsNFTs.miamiDegens;
    const assetIdentifierNYC: string = contractsNFTs.nycDegens;
    const assetIdentifierSDGUStacksPunks: string = contractsNFTs.sdguStacksPunks;
    const assetIdentifierBitcoin: string = contractsNFTs.bitcoinDegens;
    console.log(assetIdentifierBitcoin);
    if (json_obj['error'] !== undefined)
      if (json_obj['error'].includes('invalid STX address')) return <InvalidUserMessage />;

    var hasFromCollectionMiami = json_obj[typeOfToken][assetIdentifierMiami];
    var hasFromCollectionNYC = json_obj[typeOfToken][assetIdentifierNYC];
    var hasFromCollectionSDGUStacksPunks = json_obj[typeOfToken][assetIdentifierSDGUStacksPunks];
    var hasFromCollectionBitcoin = json_obj[typeOfToken][assetIdentifierBitcoin];
    console.log('hasFromCollectionBitcoin', hasFromCollectionBitcoin);
    var numberOfNftsMiami = 0;
    var numberOfNftsNYC = 0;
    var numberOfNftsSDGUStacksPunks = 0;
    var numberOfNftsBitcoin = 0;

    localStorage.setItem('miami-degens-owned', JSON.stringify([]));
    localStorage.setItem('nyc-degens-owned', JSON.stringify([]));
    localStorage.setItem('SDGU-stacks-punks-owned', JSON.stringify([]));
    localStorage.setItem('bitcoin-degens-owned', JSON.stringify([]));

    const returnAllNftsOwned = (accountAddressSelected: any, assetIdentifierCollection: any) => {
      function getIDsNFTsOwned(degens: any) {
        let ids: string[] = [];
        degens.results.forEach((x: { value: { repr: { substring: (arg0: number) => number } } }) => {
          ids.push(x.value.repr.substring(1).toString());
        });
        return ids;
      }

      const limit: number = 50;
      let offsetDegens: number = 0;
      let urlDeg: string = apiMapping[network](accountAddress).nftsOwned;

      const assetIdentifierUrl: string = `asset_identifiers=${assetIdentifierCollection}`;

      let urlDegens: string = urlDeg + assetIdentifierUrl;
      let degens = JSON.parse(Get(urlDegens));
      console.log(degens);
      let listOfNfts: string[] = [];
      listOfNfts = getIDsNFTsOwned(degens);
      const total: number = degens.total;
      offsetDegens += limit;

      while (offsetDegens < total) {
        const offsetDegensUrl: string = `&&offset=${offsetDegens}`;
        // urlDegens = urlDegens + offsetDegensUrl;
        degens = JSON.parse(Get(urlDegens + offsetDegensUrl));
        listOfNfts = listOfNfts.concat(getIDsNFTsOwned(degens));
        offsetDegens += limit;
      }
      return listOfNfts;
    };

    // TODO(andrei): Move all these to the store and add a type to it
    let nftsOwnedMiamiDegens: any[] = [];
    let nftsOwnedNYCDegens: any[] = [];
    let nftsOwnedSDGUStacksPunks: any[] = [];
    let nftsOwnedBitcoin: any[] = [];

    const verifyOwnership = () => {
      // verify correct account address
      if (JSON.parse(localStorage.getItem('userData') as any) !== accountAddress) {
        console.log('false account');
        return false;
      }

      // verify nft used is owned
      const nftSelected = localStorage.getItem('nrNFT');
      const collectionSelected = (nftSelected as any).split('#')[0];
      const numberSelected = (nftSelected as any).split('#')[1];
      console.log(collectionSelected, numberSelected);
      if (collectionSelected === 'MiamiDegen') {
        if (!nftsOwnedMiamiDegens.includes(numberSelected)) {
          return false;
        } else return true;
      } else if (collectionSelected === 'NYCDegen') {
        if (!nftsOwnedNYCDegens.includes(numberSelected)) {
          return false;
        } else return true;
      } else if (collectionSelected === 'SDGU StacksPunks') {
        if (!nftsOwnedSDGUStacksPunks.includes(numberSelected)) {
          return false;
        } else return true;
      } else if (collectionSelected === 'BitcoinDegen') {
        if (!nftsOwnedBitcoin.includes(numberSelected)) {
          return false;
        } else return true;
      } else {
        return false;
      }
    };

    if (hasFromCollectionMiami !== undefined) {
      numberOfNftsMiami = hasFromCollectionMiami['count'];
      console.log('Number of miami-degens', numberOfNftsMiami);
    }

    if (hasFromCollectionNYC !== undefined) {
      numberOfNftsNYC = hasFromCollectionNYC['count'];
    }

    if (hasFromCollectionSDGUStacksPunks !== undefined) {
      numberOfNftsSDGUStacksPunks = hasFromCollectionSDGUStacksPunks['count'];
    }

    if (hasFromCollectionBitcoin !== undefined) {
      numberOfNftsBitcoin = hasFromCollectionBitcoin['count'];
    }

    if (numberOfNftsMiami > 0) {
      var nftsOwnedMiami = returnAllNftsOwned(accountAddress, assetIdentifierMiami);
      localStorage.setItem('miami-degens-owned', JSON.stringify(nftsOwnedMiami));
      nftsOwnedMiamiDegens = nftsOwnedMiami;
    }

    if (numberOfNftsNYC > 0) {
      var nftsOwnedNYC = returnAllNftsOwned(accountAddress, assetIdentifierNYC);
      localStorage.setItem('nyc-degens-owned', JSON.stringify(nftsOwnedNYC));
      nftsOwnedNYCDegens = nftsOwnedNYC;
    }

    if (numberOfNftsSDGUStacksPunks > 0) {
      var nftsOwnedSDGUStacksPunksLocal = returnAllNftsOwned(accountAddress, assetIdentifierSDGUStacksPunks);
      localStorage.setItem('SDGU-stacks-punks-owned', JSON.stringify(nftsOwnedSDGUStacksPunksLocal));
      nftsOwnedSDGUStacksPunks = nftsOwnedSDGUStacksPunksLocal;
    }

    if (numberOfNftsBitcoin > 0) {
      var nftsOwnedBitcoinLocal = returnAllNftsOwned(accountAddress, assetIdentifierBitcoin);
      localStorage.setItem('bitcoin-degens-owned', JSON.stringify(nftsOwnedBitcoinLocal));
      nftsOwnedBitcoin = nftsOwnedBitcoinLocal;
      console.log(nftsOwnedBitcoin);
    }

    $(function () {
      if (localStorage.getItem('userData') === '') {
        return;
      }

      if (
        (numberOfNftsMiami === undefined || numberOfNftsMiami < 1) &&
        (numberOfNftsNYC === undefined || numberOfNftsNYC < 1) &&
        (numberOfNftsSDGUStacksPunks === undefined || numberOfNftsSDGUStacksPunks < 1) &&
        (numberOfNftsBitcoin === undefined || numberOfNftsBitcoin < 1)
      ) {
        return;
      }
    });

    if (numberOfNftsMiami > 0 || numberOfNftsNYC > 0 || numberOfNftsSDGUStacksPunks > 0 || numberOfNftsBitcoin > 0) {
      return (
        <div>
          <MainMenu
            accountAddressShort={accountAddressShort}
            accountAddress={accountAddress}
            nftsOwnedMiamiDegens={nftsOwnedMiamiDegens}
            nftsOwnedSDGUStacksPunks={nftsOwnedSDGUStacksPunks}
            nftsOwnedNYCDegens={nftsOwnedNYCDegens}
            nftsOwnedBitcoin={nftsOwnedBitcoin}
          />
        </div>
      );
    } else {
      // for testing the smart contract on testnet
      return (
        <div>
          <MainMenu
            accountAddressShort={accountAddressShort}
            accountAddress={accountAddress}
            nftsOwnedMiamiDegens={nftsOwnedMiamiDegens}
            nftsOwnedSDGUStacksPunks={nftsOwnedSDGUStacksPunks}
            nftsOwnedNYCDegens={nftsOwnedNYCDegens}
            nftsOwnedBitcoin={nftsOwnedBitcoin}
          />
        </div>
      );
      return <NoNFTMessage accountAddressShort={accountAddressShort} />;
    }
  } else {
    return <InvalidUserMessage />;
  }
};
